import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import PublishedDate from 'components/PublishedDate';
import { breakpoints } from 'js/breakpoints';
import fallbackImageSrc from '../../assets/image-placeholder-light.svg';
const fallbackImage = {
  src: fallbackImageSrc,
};

const NewsByCategoryBlockItem = ({
  image,
  heading,
  publishDate,
  publishDateFormatted,
  publishedLabel,
  url,
  headingTagLevel,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  return (
    <a href={url} className="news-by-category-block-item">
      <div className="news-by-category-block-item__image">
        <ResponsiveImage
          {...(image ?? fallbackImage)}
          className="responsive-image_size_news-by-category-block-item"
          loading="lazy"
          sources={[
            {
              width: 390,
              height: 230,
              media: breakpoints.xs,
            },
            {
              width: 920,
              height: 543,
              media: breakpoints.s,
            },
            {
              width: 414,
              height: 245,
              media: breakpoints.m,
            },
          ]}
        />
      </div>
      {heading && (
        <HeadingTag className="news-by-category-block-item__heading">
          {heading}
        </HeadingTag>
      )}
      {publishDate && (
        <PublishedDate
          label={publishedLabel}
          date={publishDate}
          dateFormatted={publishDateFormatted}
          className="news-by-category-block-item__published-date"
        />
      )}
    </a>
  );
};

NewsByCategoryBlockItem.propTypes = {
  image: PropTypes.exact(ResponsiveImage.propTypes),
  heading: PropTypes.string,
  publishDate: PropTypes.string,
  publishDateFormatted: PropTypes.string,
  publishedLabel: PropTypes.string,
  url: PropTypes.string.isRequired,
  headingTagLevel: PropTypes.oneOf([2, 3]),
};

NewsByCategoryBlockItem.propTypesMeta = {
  publishedLabel: 'exclude',
  headingTagLevel: 'exclude',
};

export default NewsByCategoryBlockItem;
